<template>
  <modal class="invoice-pay-credit-modal">
    <h2 class="font-bold"> Betaal de creditfactuur </h2>
    <p>
      De factuur met factuurnummer {{invoiceNumber}} is oorspronkelijk verstuurd met voorfinanciering.
      Het factuurbedrag heb je inmiddels ook betaald gekregen van The Factoring Company.
      Helaas bleek dat je factuur niet juist was.
      Daarom is de originele factuur gecrediteerd, en dien je het eerder
      betaalde bedrag terug te betalen aan The Factoring Company.
    </p>
    <section class="credit-payment-details">
      <text-row left="Factuurbedrag" :right="`€ ${creditDetails.invoice_cost}`"/>
      <text-row left="Factoringkosten (5%)" :right="`€ ${creditDetails.invoice_factoring_cost}`"/>
      <hr />
      <text-row class="bold" left="Terug te betalen"
                :right="`€ ${creditDetails.credit_cost}`" />
    </section>
    <p>
      Voordat je opnieuw je uren kunt declareren, moet het onterecht ontvangen bedrag terugbetaald worden.
      We verzoeken je om het te betalen bedrag terug te betalen
      op bankrekening NL75INGB0006466824 tnv. The Factoring Company
      onder vermelding van je bedrijfsnaam en het factuurnummer van de creditfactuur.
    </p>
    <a href="mailto:info@thefactoringcompany.nl">
      Indien je vragen hebt over het bovenstaande, neem dan contact
      op met The Factoring Company (info@thefactoringcompany.nl).
    </a>
  </modal>
</template>

<script lang="ts" setup>

import Modal from '@app/components/Modal.vue';
import TextRow from '@app/components/TextRow.vue';
import { CreditDetails } from '@app/pages/invoices/types';

defineProps<{creditDetails: CreditDetails, invoiceNumber: string}>();

</script>
<style lang='scss'>
.invoice-pay-credit-modal {

  .credit-payment-details {
    .text-row {
      padding: 0;
    }

    .bold {
      font-weight: 600;
    }

    hr {
        border: none;
        height: 1px;
        background-color: var(--pidz-black);
      }
    }

    a {
      color: var(--pidz-body-text);
      text-decoration: none;
      line-height: 12px;
    }

    .btn-link {
      font-size: 13px;
      width: 100%;
      color: var(--pidz-white);
      background-color: var(--pidz-blue);
      text-align: center;
      padding: 14px;
    }
}

</style>
